import React, { Component } from "react";
import { ReactComponent as Logo } from "../../../res/iconos/logoFooter.svg";
import { ReactComponent as IcoLinkedIn } from "../../../res/iconos/linkedin.svg";

import { useLocation } from "react-router-dom";
import textosJSON from "./textosFooter.json";

const Footer = () => {
  const location = useLocation();

  const paths = location.pathname.split("/");
  const idioma = paths[1];
  const texto = (nombre) => {
    return (textosJSON[nombre]?.[idioma])??(textosJSON[nombre]?.["es"])??""
  }

  return <React.Fragment>
    <div
      style={{
        width: "100%",
        height: "auto",
        backgroundColor: "#1e2c3a",
        paddingLeft: "10%", 
        paddingRight: "10%"
      }}
    >
      <div style={{width: "100%", height: 74}}/>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          minWidth: 200,
          gap: 30,
          flexDirection: "row",
          justifyContent: "space-between",
          //alignContent: "center",
          //alignItems: "stretch",
          paddingBottom: 44
        }}
      >
        <div 
          style={{
            flex: 1,
            width: "100%",
            display: "flex",
            gap: 20,
            flexDirection: "column",
            justifyContent: "space-between"
          }}
        >
          <p className="footer_direccion">{texto("direccion")}</p>
          <p className="footer_telefono">{texto("telefono")}</p>
        </div>
        <div 
          style={{
            flex: 1,
            width: "100%",
            minWidth: 243,
            display: "flex",
            gap: 20,
            flexDirection: "column",
            justifyContent: "space-between",
            alignContent: "flex-end",
            alignItems: "flex-end"
          }}
        >
          <Logo style={{marginRight: 0}} width={243} height={21} />
          <a className="footer_red" href="https://www.linkedin.com/company/grupocoppens-s-a">
            <IcoLinkedIn width={36}/>
          </a>
        </div>
      </div>
    </div>
</React.Fragment>;
};

export default Footer;
